import authenticationHelper from "@/AuthenticationHelper";
import { JsonServiceClient } from "@servicestack/client";

export const DefaultClient = (baseUrl?: string, basePath?: string, _theme?: string) => {

    const client = new JsonServiceClient(baseUrl)
        .apply(c => {
            c.basePath = basePath ?? null;
            c.headers = new Headers() //avoid pre-flight CORS requests
        });

    client.exceptionFilter = (res: Response, error: any) => {
        if (res.status === 401 || error.responseStatus.message === 'Unauthorized') {
            authenticationHelper.notifyUnauthorized();
        }
    };

    return client
}



export default DefaultClient;